import React, { useMemo } from "react";
import { css } from "goober";

import type { GameSymbol } from "@/app/games.mjs";
import refs from "@/shared/match-tile-ad.refs.mjs";
import { useGameSymbol } from "@/util/game-route.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

const cssMatchTileAds = () => css`
  > *:not(:first-child) {
    display: none;
  }
`;

export type MatchTileAd = {
  id: string;
  /*
    There are no tiebreakers so don't double up on prios
    3 is reserved for Battles sponsored events
    10 for Pro
  */
  priority: number;
  Component: (props: { gameSymbol: GameSymbol }) => React.ReactNode;
};

export function MatchTileAd() {
  const { tiles } = useSnapshot(refs);
  const gameSymbol = useGameSymbol();

  const adTiles = useMemo(() => {
    return [...tiles].sort((a, b) => a.priority - b.priority);
  }, [tiles]);

  return (
    <div className={cssMatchTileAds()}>
      {adTiles.map((adTile) => (
        <adTile.Component key={adTile.id} gameSymbol={gameSymbol} />
      ))}
    </div>
  );
}
